<template>
  <qx-card title="银行卡列表">
    <section class="tablePage">
      <section class="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          empty-text="该用户尚未绑定银行卡，请通知绑卡。"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
          >
            <section slot-scope="scope">
              <section v-if="scope.column.property === 'bankType'">
                <span>{{ scope.row.bankType === 0 ? '私户' : '公户' }}</span>
              </section>
              <section v-else>
                <span>{{ scope.row[scope.column.property] }}</span>
              </section>
            </section>
          </el-table-column>
        </el-table>
      </section>
      <section class="paginationBox clearPa">
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
      </section>
    </section>
  </qx-card>
</template>
<script>
import tableMixin from '@qx/mixin/table';
import {
  queryAccountBankRel,
} from 'api/operate';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'acctName',
            label: '账户名',
          },
          {
            prop: 'acctNo',
            label: '银行账户',
          },
          {
            prop: 'bankType',
            label: '类型',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: queryAccountBankRel,
  },
};
</script>
<style lang="scss" scoped>
</style>
